import React, { useState } from "react";
import { SiInstagram } from "react-icons/si";

const Team = () => {
  const [teamImgHoverState, setteamImgHoverState] = useState("");
  const showLinks = (memberName) => {
    setteamImgHoverState(memberName);
  };
  const hideLinks = () => {
    setteamImgHoverState("");
  };
  return (
    <div className="section-container flex flex-col items-center" id="team">
      <h3 className="section-title">Meet the Team</h3>
      {/* Team member cards */}
      <div className="w-full mt-16 flex flex-none justify-around items-center flex-wrap">
        <div className="w-72 mb-4 flex flex-col items-center justify-between">
          <div
            onMouseEnter={() => showLinks("het")}
            onMouseLeave={() => hideLinks()}
            className="teamImgStyle bg-het-img"
          >
            {teamImgHoverState === "het" ? (
              <a href="https://instagram.com/hettzz_?igshid=YmMyMTA2M2Y=" target="_blank" rel="noreferrer">
                <SiInstagram className="teamImgInstaButtonStyle" size="3rem" />
              </a>
            ) : (
              <span></span>
            )}
          </div>
          <h3 className="text-3xl text-gray-200 font-title mt-6 mb-4 font-semibold text-center">
            Het Kothari
          </h3>
        </div>
        <div className="w-72 mb-4 flex flex-col items-center justify-between">
          <div
            onMouseEnter={() => showLinks("prajwal")}
            onMouseLeave={() => hideLinks()}
            className="teamImgStyle bg-prajwal-img"
          >
            {teamImgHoverState === "prajwal" ? (
              <a href="https://instagram.com/photoholic_1o?igshid=YmMyMTA2M2Y=" target="_blank" rel="noreferrer">
                <SiInstagram className="teamImgInstaButtonStyle" size="3rem" />
              </a>
            ) : (
              <span></span>
            )}
          </div>
          <h3 className="text-3xl text-gray-200 font-title mt-6 mb-4 font-semibold text-center">
            Prajwal Gawde
          </h3>
        </div>
        <div className="w-72 mb-4 flex flex-col items-center justify-between">
          <div
            onMouseEnter={() => showLinks("krishna")}
            onMouseLeave={() => hideLinks()}
            className="teamImgStyle bg-krishna-img"
          >
            {teamImgHoverState === "krishna" ? (
              <a href="https://instagram.com/krishna_bhanushali?igshid=YmMyMTA2M2Y=" target="_blank" rel="noreferrer">
                <SiInstagram className="teamImgInstaButtonStyle" size="3rem" />
              </a>
            ) : (
              <span></span>
            )}
          </div>
          <h3 className="text-3xl text-gray-200 font-title mt-6 mb-4 font-semibold text-center">
            Krishna Bhanushali
          </h3>
        </div>
        <div className="w-72 mb-4 flex flex-col items-center justify-between">
          <div
            onMouseEnter={() => showLinks("daniel")}
            onMouseLeave={() => hideLinks()}
            className="teamImgStyle bg-daniel-img"
          >
            {teamImgHoverState === "daniel" ? (
              <a href="https://instagram.com/danthemansz?igshid=YmMyMTA2M2Y=" target="_blank" rel="noreferrer">
                <SiInstagram className="teamImgInstaButtonStyle" size="3rem" />
              </a>
            ) : (
              <span></span>
            )}
          </div>
          <h3 className="text-3xl text-gray-200 font-title mt-6 mb-4 font-semibold text-center">
            Daniel George
          </h3>
        </div>
      </div>
    </div>
  );
};
export default Team;
